import React, { useContext } from 'react';
import { 
  FileExcelOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileImageOutlined,
  FileOutlined,
  FileTextOutlined,
  CopyOutlined,
  LikeOutlined,
  DislikeOutlined,
  DislikeFilled,
  LikeFilled
} from '@ant-design/icons';
import { message as antMessage } from 'antd';
import { downloadFile } from '../../utils/fileUtils';
import Markdown from 'markdown-to-jsx'
import useHttp from '../../hooks/useHttp';
import { API_URL } from '../../services/api';
import ChatContext from '../../store/ChatContext';
import AuthContext from "../../store/AuthContext";
import { getPathFromContext } from '../../utils/pathUtils';

import he from 'he';
const ChatMessage = ({ message, setMessages}) => {
  const chatCtx = useContext(ChatContext);
  const authCtx = useContext(AuthContext);
  const MyCustomLink = ({ children, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer">{children}</a>
  );

  const MyCustomTable = ({ children, ...props }) => (
    <div className="max-w-full overflow-auto max-h-[250px] chatTable">
      <table {...props}>{children}</table>
    </div>
  );

  const getFileIcon = (fileName) => {
    const extension = fileName?.split('.').pop().toLowerCase();
    switch (extension) {
      case 'xlsx':
      case 'xls':
      case 'csv':
        return <FileExcelOutlined className="text-green-600" />;
      case 'pdf':
        return <FilePdfOutlined className="text-red-600" />;
      case 'doc':
      case 'docx':
        return <FileWordOutlined className="text-blue-600" />;
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return <FileImageOutlined className="text-purple-600" />;
      case 'txt':
        return <FileTextOutlined className="text-gray-600" />;
      default:
        return <FileOutlined className="text-gray-600" />;
    }
  };

  const { postRequest } = useHttp();

  function copyToClipboard() {
    try {
      const textarea = document.createElement("textarea");
      textarea.value = message.content;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      antMessage.success('Copied to clipboard');
    } catch (error) {
      console.error('Failed to copy: ', error);
    }
  }


  const updateUserChatSentiment = (sentiment) => {
    const contextPath = getPathFromContext(chatCtx);
    postRequest({
      url: API_URL + `/app/${contextPath}/agent/chat/userfeedback`,
      data: {
        // "agentId":chatCtx.agentId,//remove
        "chatMessageIdentifier":message.chatMessageIdentifier,
        "userChatSentiment": message.userChatSentiment===sentiment? 'NEUTRAL': sentiment,
        "chatIdentifier":chatCtx.connectionId,
        "messageDate":message.messageDate
    }, onResponse: (response) => {      
      setMessages(prevMessages => prevMessages.map(msg => 
            msg.chatMessageIdentifier === message.chatMessageIdentifier 
              ? { ...msg, userChatSentiment: response.userChatSentiment } 
              : msg
      ));
    }, onError: (error) => {
        console.log(error);
    }, showLoader: false
    });
  };

  const handleLike = () => {
    updateUserChatSentiment('POSITIVE');
  };

  const handleDislike = () => {
    updateUserChatSentiment('NEGATIVE');
  };

  return (
    <>
    <div key={message.chatMessageIdentifier} id={`${message.chatMessageIdentifier}`} className={`flex items-start gap-4 ${message.isUser ? 'flex-row-reverse' : ''}`}>
      
      
      <div 
        className={`
          max-w-[85%] sm:max-w-[90%] rounded-xl min-w-[30%]
          ${'text-gray-800'}
          ${message.isUser ? '!bg-gray-200  p-4' : 'bg-white'}
        `}
      >
        <div className="whitespace-pre-wrap leading-relaxed">
          {<Markdown options={{
            overrides: {
              a: {
                component: MyCustomLink,
              },
              table: {
                component: MyCustomTable,
              },
            },
          }}>{he.decode(message.content)}</Markdown>}
          
        </div>
        {message.files && message.files.length > 0 && (
          <div className="mb-3 flex flex-wrap gap-2">
            {message.files.map((file, index) => (
              <div 
                key={index} 
                onClick={() => {
                  const contextPath = getPathFromContext(chatCtx);
                  downloadFile(file, contextPath);
                }}
                className={`
                  flex items-center gap-2 rounded-lg p-2 cursor-pointer
                  ${ 
                    'bg-gray-50 hover:bg-gray-100 border border-gray-200'
                  }
                  transition-colors duration-150
                `}
              >
                {getFileIcon(file.fileName)}
                <span className={`truncate text-sm max-w-[200px] ${'text-gray-700'}`} title={file.fileName}>
                  {file.fileName}
                </span>
              </div>
            ))}
          </div>
        )}
        
        {message.isUser &&
         <div className="mt-3">
          <div className='text-[10px] text-right text-gray-500'>{message.messageDate && new Date(message.messageDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) +' at '+ new Date(message.messageDate).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</div>
          </div>}
        {!message.isUser && (
         <div className='flex justify-between items-center'>
           <div className="flex items-center gap-2 mt-2">
            <button
              onClick={copyToClipboard}
              className="flex items-center text-gray-500 hover:text-gray-700 transition-colors"
            >
                <CopyOutlined className="text-lg" />
            </button>
            <button
              onClick={handleLike}
              className="flex items-center text-gray-500 hover:text-gray-700 transition-colors"
            >
                {message.userChatSentiment === 'POSITIVE' ? <LikeFilled className="text-lg" /> : <LikeOutlined className="text-lg" />}
            </button>
            <button
              onClick={handleDislike}
              className="flex items-center text-gray-500 hover:text-gray-700 transition-colors"
            >
              {message.userChatSentiment === 'NEGATIVE' ? <DislikeFilled className="text-lg" /> : <DislikeOutlined className="text-lg" />}
            </button>
          </div>
            <div className='text-[10px] text-right text-gray-500'>{message.messageDate && new Date(message.messageDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })+' at '+ new Date(message.messageDate).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</div>
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default ChatMessage;
